module.exports = __webpack_public_path__ + "zvetseni-prsou_47_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_47_after.jpg
// module id = 1341
// module chunks = 0